export default __webpack_public_path__ + "static/media/IMG_0071.c326e8f0.jpeg";